import React from "react";
import { InlineMath, BlockMath } from "react-katex";
import FractionInput, {
  parseFractionLikeInput as parseFraction,
  formatLatexPreview,
} from "../../../../components/inputs/FractionInput";

const DEC_TOL = 0.01;
const pick = (arr) => arr[Math.floor(Math.random() * arr.length)];

export function generateTask() {
  const A = Array.from({ length: 18 }, (_, i) => i + 3); // 3..20
  const a = pick(A);
  const h = pick(A);
  const P = a * h;
  return { type: "ParallelogramAreaFromSideAndHeightTask", data: { a, h, P } };
}

export function renderTask({ data }) {
  const { a, h } = data;
  return (
    <div style={{ marginTop: 8, marginBottom: 8 }}>
      Dany jest równoległobok o boku <InlineMath math={'a='+a} /> i wysokości <InlineMath math={'h_a='+h} />.
      Oblicz jego pole <InlineMath math={'P'} />.
    </div>
  );
}

export function renderInput(_task, userAnswer, onChange, disabled) {
  const raw = typeof userAnswer === "string" ? userAnswer : userAnswer?.raw ?? "";
  const normalize = (v) => (typeof v === "string" ? v : v?.raw ?? "");
  return (
    <FractionInput
      value={raw}
      onChange={(v) => onChange({ raw: normalize(v) })}
      disabled={disabled}
      label="P"
      placeholder="np. 60"
    />
  );
}

export function checkAnswer({ data }, userAnswer) {
  const raw = typeof userAnswer === "string" ? userAnswer : userAnswer?.raw ?? "";
  if (!raw) return false;
  const val = parseFraction(raw);
  return Number.isFinite(val) && Math.abs(val - data.P) <= DEC_TOL;
}

export const renderAnswer = ({ data }) => <InlineMath math={'P='+data.P} />;

export function renderExplanation({ data }) {
  const { a, h, P } = data;
  return (
    <div style={{ textAlign: "left", lineHeight: 1.7 }}>
      <strong>Krok 1.</strong> Wzór na pole: <InlineMath math={'P=a\\cdot h_a'} />.
      <BlockMath math={`P=${a}\\cdot ${h}=${P}`} />
    </div>
  );
}

export function renderUserAnswer(userAnswer) {
  const raw = typeof userAnswer === "string" ? userAnswer : userAnswer?.raw ?? "";
  if (!raw) return <i>(brak odpowiedzi)</i>;
  return <InlineMath math={formatLatexPreview(raw, 'P')} />;
}

export default {
  generateTask,
  renderTask,
  renderInput,
  checkAnswer,
  renderAnswer,
  renderExplanation,
  renderUserAnswer,
};